import { useState } from "react";
import {
  Motion,
  spring,
  presets
} from 'react-motion';
import "../../Assets/css/animation.css";
import { AnimatePresence, motion } from "framer-motion";

import { CheckboxGroup, Checkbox } from "@nextui-org/react";
import Navibar from "../../components/navigationbar/navigationbar";

function Animation() {

  

    

  const [show, setShow] = useState(true);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const btnFn = () => {
      setIsAnimating(!isAnimating);
  };
  return (
    <div className="App1" style={{ position: 'relative', width: '100vw', height: '100vh', backgroundColor: '#f5f5dc' }}>
  
  <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Navibar />
      </div>

      <CheckboxGroup
        label="Select cities"
        defaultValue={["buenos-aires", "london"]}
      >
        <Checkbox value="buenos-aires">Buenos Aires</Checkbox>
        <Checkbox value="sydney">Sydney</Checkbox>
        <Checkbox value="san-francisco">San Francisco</Checkbox>
        <Checkbox value="london">London</Checkbox>
        <Checkbox value="tokyo">Tokyo</Checkbox>
      </CheckboxGroup>
      <br />
     
      <button onClick={() => setShow(!show)}>
        {show ? "Hide" : "Show"}
      </button>

      <AnimatePresence>
        {show && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            This is a motion div
          </motion.div>
        )}
      </AnimatePresence>

        <br/><br/>
        <motion.div style={{ 
            color: 'green', 
            fontSize: 20, 
            width: '300px', 
            height: '30px', 
            textAlign: 'center', 
            border: '2px solid green', 
            margin: '40px'
        }} 
  
            whileHover={{ scale: 0.5 }} 
        > 
            GeeksforGeeks 
        </motion.div> 


        <div style={
            {
                textAlign: 'center',
                marginTop: '50px'
            }}>
            <Motion
                defaultStyle={
                    {
                        opacity: 0,
                        translateY: -100,
                        scale: 0,
                        rotate: 0
                    }}
                style={{
                    opacity: spring(isAnimating ? 1 : 0, { precision: 0.1 }),
                    translateY: spring(isAnimating ? 0 : -100, presets.gentle),
                    scale: spring(isAnimating ? 1 : 0, presets.wobbly),
                    rotate: spring(isAnimating ? 360 : 0),
                }}>
                {
                    (interpolatingStyle) => (
                        <div
                            style={{
                                opacity: interpolatingStyle.opacity,
                                transform: `translateY
                                            (${interpolatingStyle.translateY}px) 
                                            scale(${interpolatingStyle.scale}) 
                                            rotate(${
                                                interpolatingStyle.rotate
                                             }deg)`,
                                transition: 'opacity 0.5s, transform 0.5s',
                                background: 'lightblue',
                                padding: '20px',
                                borderRadius: '8px',
                            }}>
                            <h1 style={
                                { color: 'green' }}>GeeksforGeeks</h1>
                            <h3>React Motion Package in ReactJS</h3>
                        </div>
                    )
                }
            </Motion>
            <button
                style={{
                    marginTop: '20px',
                    padding: '10px 20px',
                    fontSize: '16px',
                    cursor: 'pointer',
                    background: 'orange',
                    border: 'none',
                    borderRadius: '4px',
                }}
                onClick={btnFn}>
                {isAnimating ? 'Hide' : 'Show'} Animation
            </button>
        </div>


        <br/>
        <div className='body11'>
        <div id="gfg1">
        <div id="geek1">
            GeeksforGeeks
        </div>
        <div id="geek2">
            A computer science portal for geeks
        </div>
    </div>
    </div>

    <br/>

    <div className="app1">
            <h1 className="title">
                Card Flip Animation
            </h1>
            <div
                className="card-container"
                onMouseEnter={
                    () => setIsHovered(true)}
                onMouseLeave={
                    () => setIsHovered(false)}>
                <Motion
                    defaultStyle={{ rotateY: 0 }}
                    style={{
                        rotateY: spring(isHovered ? 180 : 0,
                            { stiffness: 120, damping: 10 }) }}>
                    {({ rotateY }) => (
                        <div
                            className="card"
                            style={{
                                transform: `rotateY(${rotateY}deg)`,
                            }}>
                            <div className="front">Front</div>
                            <div className="back">Back</div>
                        </div>
                    )}
                </Motion>
            </div>
        </div>
    </div>
  );
}

export default Animation;
